import React from 'react';
import { Settings, LogOut, Bell, Info } from 'lucide-react';
import { useFirebaseAuth } from '../../hooks/useFirebaseAuth';
import { useNavigate } from 'react-router-dom';

export function MobileSettingsPage() {
  const { logout } = useFirebaseAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="p-4 pt-16">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-white">Configurações</h1>
        <p className="text-gray-400 text-sm">Gerencie suas preferências</p>
      </div>

      <div className="space-y-4">
        <div className="bg-[#1A1D23] rounded-lg">
          <button className="w-full flex items-center justify-between p-4 text-white">
            <div className="flex items-center gap-3">
              <Bell className="w-5 h-5 text-[#268c73]" />
              <span>Notificações</span>
            </div>
            <div className="relative">
              <input type="checkbox" className="sr-only peer" />
              <div className="w-11 h-6 bg-gray-700 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#268c73]"></div>
            </div>
          </button>
        </div>

        <div className="bg-[#1A1D23] rounded-lg">
          <button className="w-full flex items-center justify-between p-4 text-white">
            <div className="flex items-center gap-3">
              <Info className="w-5 h-5 text-[#268c73]" />
              <span>Sobre o App</span>
            </div>
            <span className="text-sm text-gray-400">v1.0.0</span>
          </button>
        </div>

        <button
          onClick={handleLogout}
          className="w-full bg-red-600 text-white rounded-lg py-4 flex items-center justify-center gap-2 hover:bg-red-700 transition-colors"
        >
          <LogOut className="w-5 h-5" />
          Sair
        </button>
      </div>
    </div>
  );
}